import script from "./MenorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenorModal.vue?vue&type=script&setup=true&lang=ts"

import "./MenorModal.vue?vue&type=style&index=0&id=c486ac26&lang=css"

const __exports__ = script;

export default __exports__